import React from 'react';
import PropTypes from 'prop-types';
import useClassNames from '@medflex/hooks/useClassNames';
import IconUserGroup from '../icons/UserGroup';

const EmptyState = ({ title, boxLabels, children, kind }) => {
  const cnBar = useClassNames(
    () => [
      'rounded-lg',
      'p-2',
      'w-full',
      kind === 'slate' && 'bg-slate-300',
      kind === 'default' && 'bg-blue-300',
      kind === 'group' && 'bg-blue-700',
    ],
    [kind],
  );

  return (
    <div className="flex-1">
      <h2 className="font-semibold text-xl text-center mt-12 mx-16 text-slate-600">{title}</h2>
      <div className="mt-8 px-16 flex flex-col space-y-6">
        {boxLabels.map(item => (
          <div
            key={item}
            className="p-2 text-sm text-slate-400 rounded-lg border flex space-x-4 items-center even:-mr-8 odd:-ml-8"
          >
            {kind !== 'group' && (
              <div
                className={`rounded-full bg-opacity-75 p-6 ${
                  kind === 'slate' ? 'bg-slate-300' : 'bg-blue-200'
                }`}
              />
            )}
            {kind === 'group' && (
              <IconUserGroup
                size="12"
                className="text-white fill-current bg-blue-700 rounded-full p-3"
              />
            )}
            <div className="flex flex-col flex-1">
              <div className={cnBar} />
              <div className="mt-1">{item}</div>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-8 text-center text-slate-600 mx-4">{children}</div>
    </div>
  );
};

EmptyState.defaultProps = {
  boxLabels: [],
  kind: 'default',
};

EmptyState.propTypes = {
  boxLabels: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node,
  kind: PropTypes.oneOf(['default', 'slate', 'group']),
  title: PropTypes.string,
};

export default EmptyState;
